var auto = {};
export {
  auto as __exports
};
//# sourceMappingURL=index225.js.map
